/**
 * Estilos para el componente ReCaptcha.
 *
 * Define la apariencia visual del widget de reCAPTCHA y sus estados de error.
 *
 * @param {object} theme - El tema de Material-UI
 * @returns {object} Objeto con clases de estilos para el componente
 */
export const recaptchaStyles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  recaptchaWrapper: {
    display: 'inline-block',
    borderRadius: '4px',
    transition: 'all 0.3s ease',
    '& > div': {
      // Estilos para el iframe de reCAPTCHA
      borderRadius: '4px',
    },
  },
  error: {
    border: `2px solid ${theme.palette.error.main}`,
    borderRadius: '4px',
    padding: '2px',
    animation: '$shake 0.5s',
  },
  errorMessage: {
    marginTop: theme.spacing(0.5),
    marginLeft: theme.spacing(1.75),
    fontSize: '0.75rem',
  },
  '@keyframes shake': {
    '0%, 100%': {
      transform: 'translateX(0)',
    },
    '10%, 30%, 50%, 70%, 90%': {
      transform: 'translateX(-5px)',
    },
    '20%, 40%, 60%, 80%': {
      transform: 'translateX(5px)',
    },
  },
})
